<div class="int-calendar">
  <int-year-selector
    intDateStateController
    [date]="_currentDate"
    [showNavigations]="true"
    [type]="'range'"
    (onSelect)="onSelect($event)"
  >
    <int-month-list></int-month-list>
  </int-year-selector>
</div>

